import LoginPage from "./login";

export default function SplashScreen() {
    return <LoginPage intro />;
}
